export default __webpack_public_path__ + "static/media/Domene.c129c1ca.png";